import styles from '../BookingWidget.module.css';

interface EntryStepProps {
  onPurchase: () => void;
  onRedeem: () => void;
}

export function EntryStep({ onPurchase, onRedeem }: EntryStepProps) {
  return (
    <div className={styles.list}>
      <button type="button" className={styles.card} onClick={onPurchase}>
        <p className={styles.cardTitle}>Neu buchen</p>
        <p className={styles.cardMeta}>
          Einzelstunde, 10er-Abo oder Schnupper-Angebot kaufen
        </p>
      </button>
      <button type="button" className={styles.card} onClick={onRedeem}>
        <p className={styles.cardTitle}>Guthaben einlösen</p>
        <p className={styles.cardMeta}>
          Mit bestehendem 10er-Abo einen weiteren Termin buchen
        </p>
      </button>
    </div>
  );
}
